
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
    selector: 'settings-security',
    templateUrl: './security.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule, MatProgressSpinnerModule, MatButtonModule]
})
export class SettingsSecurityComponent
{
    flashMessage: 'error' | null = null;
    redirecting: boolean = false;
    /**
     * Password change is only possible for password accounts (method 1).
     * Users federated through their company IdP (OKTA / Azure / Google)
     * manage their password with their organization, not through us.
     */
    isPasswordUser: boolean = localStorage.getItem('method_id') === '1';

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _authService: AuthService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Passwords are managed in OKTA: fetch a one-time hosted password-change
     * URL and send the user there.
     */
    changePasswordOkta(): void {
        this.redirecting = true;
        this._changeDetectorRef.markForCheck();

        this._authService.changePasswordOkta()
            .subscribe(
                (response) => {
                    const url = response?.data?.changePasswordOkta?.url;

                    if (response?.errors || !url) {
                        this.redirecting = false;
                        this.showFlashMessage('error');
                        return;
                    }

                    window.location.href = url;
                },
                () => {
                    this.redirecting = false;
                    this.showFlashMessage('error');
                }
            );
    }

    /**
     * Show flash message
     */
    showFlashMessage(type: 'error'): void {
        // Show the message
        this.flashMessage = type;

        // Mark for check
        this._changeDetectorRef.markForCheck();

        // Hide it after 4 seconds
        setTimeout(() => {

            this.flashMessage = null;

            // Mark for check
            this._changeDetectorRef.markForCheck();
        }, 4000);
    }
}
